import React, { useEffect } from 'react';

const Image = () => {
  React.useEffect(() => {
    // eslint-disable-next-line no-console
    console.warn('Placeholder: Image is not implemented yet.');
  }, []);
  return (
    <>
  { /*Image */} 
 </>
  );
};

export default Image;
